import { render } from "./product-related-products.vue?vue&type=template&id=a0e06ac2&lang=pug"
import script from "./product-related-products.vue?vue&type=script&lang=js"
export * from "./product-related-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__